export default __webpack_public_path__ + "img/1_10-8e903bae.png";